module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui segment",
    staticStyle: {
      "height": "100px"
    }
  }, [_c('div', {
    staticClass: "ui active inverted dimmer"
  }, [_c('div', {
    staticClass: "ui text loader"
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('p')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-17a79fc8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LogoutPage.vue
// module id = 322
// module chunks = 1